//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ProvenResults',
  props: {
    summary: {
      type: Array,
      default: () => []
    },
    results: {
      type: Array,
      default: () => []
    },
    report: {
      type: Object,
      default: () => ({
        url: '',
        text: ''
      })
    },
    image: {
      type: Object,
      default: () => ({
        url: '',
        alt: ''
      })
    },
    youTubeVideoId: {
      type: String,
      default: ''
    }
  }
};
